import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';
import { environment } from 'environments/environment';

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        {
            // Provide the default Transloco configuration
            provide : TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs      : [
                    {
                        id   : 'br',
                        label: 'Português'
                    },
                    {
                        id   : 'es',
                        label: 'Español'
                    }
                ],
                defaultLang         : 'br',
                fallbackLang        : 'br',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            })
        },
        {
            // Provide the default Transloco loader
            provide : TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide   : APP_INITIALIZER,
            deps      : [TranslocoService],
            useFactory: (translocoService: TranslocoService): any => (): Promise<Translation> => {
                const getCookie = (name: string): string | null => {
                    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                    return match ? decodeURIComponent(match[2]) : null;
                };

                const cookieLang = getCookie('selectedLanguage');
                const savedLang = cookieLang || localStorage.getItem('selectedLanguage');

                if (savedLang) localStorage.setItem('selectedLanguage', savedLang);

                const langToUse = savedLang && ['br', 'es'].includes(savedLang) ? savedLang : translocoService.getDefaultLang();

                translocoService.setActiveLang(langToUse);
                return translocoService.load(langToUse).toPromise();
            },
            multi     : true
        }
    ]
})
export class TranslocoCoreModule
{
}
